import React, { useState, useContext, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import { DataInContext } from '../../context/DataInContext'
import { jwtDecode } from "jwt-decode"
import "./ModalNewInd.scss"

function ModalEditIndicador(props) {
    const { 
        editIndicador, 
        setEditIndicador,
        setLoading, 
        fetchIndicadores, 
        setError, 
        setIndicadores, 
        etiquetas,
        asignarEtiquetas,
        etiquetasSeleccionadas, 
        setEtiquetasSeleccionadas,
        desasignarEtiquetas
    } = useContext(DataInContext)

    const auth = localStorage.getItem("token")
    const jwtParse = jwtDecode(auth)
    const USER = jwtParse.apirest.objeto

    const [userDatos, setUserDatos] = useState({
        area: "",
        indicador: "",
        descripcion: "",
        frecuencia: "",
        responsable: "",
        suplente: ""
    })
    const [errores, setErrores] = useState({})
    const [modalErr, setModalErr] = useState(null)

    const [inputValue, setInputValue] = useState("")
    const [sugerenciasVisibles, setSugerenciasVisibles] = useState(false);

    useEffect(() => {
        if(editIndicador) {
            const obj = JSON.parse(editIndicador)
            setUserDatos({
                area: obj.Areas.nombre,
                indicador: obj.nombre_indicador,
                descripcion: obj.detalles_metrica,
                frecuencia: obj.tipo_recordartorio.toString(),
                responsable: obj.Empleados[0].mail,
                suplente: obj.Empleados[1].mail,
            })
            setInputValue(obj.Etiquetas.map((e)=>e.nombre_etiqueta).join(", "))
            // Etiquetas
            const arr = etiquetas.filter(e =>
                obj.Etiquetas.some(f => e.id_etiqueta === f.id_etiqueta)
            );
            setEtiquetasSeleccionadas(arr)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[editIndicador])
    

    const validateFormDatos = (data) => {
        const errors = {}
    
        // if(!data.area.trim()) {
        //     errors.area = "Escriba el nombre del Área o Proyecto."
        // }
        if(!data.indicador.trim()) {
            errors.indicador = "Escriba un nombre para el indicador."
        }
        if(!data.descripcion.trim()) {
            errors.descripcion = "Escriba un texto para la descripcion."
        }
        if(!data.frecuencia.trim()) {
            errors.frecuencia = "Elija una frecuencia."
        }
        if(data.responsable === data.suplente){
            errors.responsable = "No puede ser el mismo mail."
            errors.suplente = "No puede ser el mismo mail."
        } else {
            if(!data.responsable.trim()) {
                errors.responsable = "Escriba el mail."
            } else if (!/\S+@\S+\.\S+/.test(data.responsable)){
                errors.responsable = "El email no es válido."
            }
            if(!data.suplente.trim()) {
                errors.suplente = "Escriba el mail."
            } else if (!/\S+@\S+\.\S+/.test(data.suplente)){
                errors.suplente = "El email no es válido."
            }
        }
        return errors;
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserDatos({
          ...userDatos,
          [name]: value,
        })
      }
    
    const handleClose = () => {
        props.onHide()
        setErrores({})
        setModalErr(null)
        setUserDatos({
            area: "",
            indicador: "",
            descripcion: "",
            frecuencia: "",
            responsable: "",
            suplente: ""
        })
        setEditIndicador(null)
        setInputValue("")
        setEtiquetasSeleccionadas([])
    }

    const handleChangeIndicador = async (e) => {
        e.preventDefault()
        const obj = JSON.parse(editIndicador)
        const newErrors = validateFormDatos(userDatos);
        setErrores(newErrors)
        if (Object.keys(newErrors).length === 0){
            const objInd = {
                user: USER,
                indicador: obj,
                nombre_indicador: userDatos.indicador,
                detalles_metrica: userDatos.descripcion,
                tipo_recordartorio: parseInt(userDatos.frecuencia),
                responsable: userDatos.responsable,
                empleadoSuplente: userDatos.suplente
            }
            setLoading(true)
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn/editIndicador`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(objInd)
                })
                const data = await res.json()
                const errorCode = data.error ?? data.status;
                if(errorCode !== 0){
                    setModalErr(data.errorDetalle || data.codeError)
                    return
                }

                const arrIndicadorEtiquetas = obj.Etiquetas

                // asignar etiqueta
                const asignarEtiq = etiquetasSeleccionadas.filter(x => 
                    !arrIndicadorEtiquetas.some(y => y.id_etiqueta === x.id_etiqueta)
                )
                // desasignar etiqueta
                const desasignarEtiq = arrIndicadorEtiquetas.filter(x => 
                    !etiquetasSeleccionadas.some(y => y.id_etiqueta === x.id_etiqueta)
                )

                await Promise.all([
                    asignarEtiquetas(asignarEtiq, obj.id_indicador),
                    desasignarEtiquetas(desasignarEtiq, USER)
                ])
                
                const dataInd = await fetchIndicadores()
                if(dataInd.error){
                    setError(dataInd.errorDetalle)
                } else {
                    setIndicadores(dataInd.objeto)
                }
                handleClose()
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            } finally {
                setLoading(false)
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    const ultimaPalabra = inputValue.split(',').pop().trim();
    
    const sugerenciasFiltradas = etiquetas.filter(
        (opcion) =>
            opcion.nombre_etiqueta.toLowerCase().includes(ultimaPalabra.toLowerCase()) &&
            !etiquetasSeleccionadas.find((sel) => sel.id_etiqueta === opcion.id_etiqueta)
    );
    
    const handleChangeEtiquetas = (e) => {
        const nuevoValor = e.target.value;
        setInputValue(nuevoValor);
        setSugerenciasVisibles(true);

        const palabras = nuevoValor
            .split(',')
            .map((p) => p.trim())
            .filter((p) => p.length > 0);

        // Solo mantener etiquetas válidas y seleccionadas del listado original
        const nuevasEtiquetas = etiquetas.filter((e) =>
            palabras.includes(e.nombre_etiqueta)
        );

        setEtiquetasSeleccionadas(nuevasEtiquetas);
    }
    
    const handleClickOpcion = (opcion) => {
        if (!etiquetasSeleccionadas.find((e) => e.id_etiqueta === opcion.id_etiqueta)) {
            const nuevas = [...etiquetasSeleccionadas, opcion];
            setEtiquetasSeleccionadas(nuevas);
            setInputValue(nuevas.map((e) => e.nombre_etiqueta).join(', '));
        }
        setSugerenciasVisibles(true);
    };
    
    const handleFocus = () => {
        setSugerenciasVisibles(true);
    };

    const handleBlur = () => {
        setTimeout(() => setSugerenciasVisibles(false), 100); // Espera para permitir click
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modal__editIndicador'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    <h3 className='m-0'>Modificar Indicador</h3>
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleChangeIndicador} className='form__editarIndicador w-100 d-flex flex-column align-items-center'>
                    {/* Nombre del indicador */}
                    <div className='w-100 d-flex flex-column flex-md-row align-items-center mb-2'>
                        <label className='me-1 col-12 col-md-3 col-form-label'>Nombre del indicador</label>
                        <div className='d-flex flex-column col-12 col-md-9'>
                            <input
                                autoFocus
                                onChange={handleChange}
                                type="text"  
                                name="indicador" 
                                className="form-control form-control-sm"
                                value={userDatos.indicador}
                            />
                            {errores.indicador && <span className='form__editarIndicador--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errores.indicador}</span>}
                        </div>
                    </div>
                    {/* Descripción del indicador */}
                    <div className='w-100 d-flex flex-column flex-md-row align-items-center mb-2'>
                        <label className='me-1 col-12 col-md-3 col-form-label'>Descripción del indicador</label>
                        <div className='d-flex flex-column col-12 col-md-9'>
                            <input
                                onChange={handleChange}
                                type="text"  
                                name="descripcion" 
                                className="form-control form-control-sm"
                                value={userDatos.descripcion}
                            />
                            {errores.descripcion && <span className='form__editarIndicador--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errores.descripcion}</span>}
                        </div>
                    </div>
                    {/* Frecuencia de carga */}
                    <div className="w-100 d-flex flex-column flex-md-row align-items-center mb-2">
                        <label className='me-1 col-12 col-md-3 col-form-label'>Frecuencia</label>
                        <div className='d-flex flex-column col-12 col-md-3'>
                            <select 
                                className="form-select form-select-sm" 
                                name="frecuencia" 
                                onChange={handleChange} 
                                value={userDatos.frecuencia}
                            >
                                <option value="">Elija la frecuencia</option>
                                <option value="1">Semanal</option>
                                <option value="2">Quincenal</option>
                                <option value="3">Mensual</option>
                                <option value="4">Trimestral</option>
                            </select>
                            {errores.frecuencia && <span className='form__editarIndicador--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errores.frecuencia}</span>}
                        </div>
                    </div>
                    {/* Email del responsable */}
                    <div className='w-100 d-flex flex-column flex-md-row align-items-center mb-2'>
                        <label className='me-1 col-12 col-md-3 col-form-label'>Responsable</label>
                        <div className='d-flex flex-column col-12 col-md-9'>
                            <input
                                onChange={handleChange}
                                type="email"  
                                name="responsable" 
                                placeholder="usuario@correo.com.ar"
                                className="form-control form-control-sm"
                                value={userDatos.responsable}
                            />
                            {errores.responsable && <span className='form__editarIndicador--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errores.responsable}</span>}
                        </div>
                    </div>
                    {/* Email del suplente */}
                    <div className='w-100 d-flex flex-column flex-md-row align-items-center mb-2'>
                        <label className='me-1 col-12 col-md-3 col-form-label'>Responsable suplente</label>
                        <div className='d-flex flex-column col-12 col-md-9'>
                            <input
                                onChange={handleChange}
                                type="email"  
                                name="suplente" 
                                placeholder="usuario@correo.com.ar"
                                className="form-control form-control-sm"
                                value={userDatos.suplente}
                            />
                            {errores.suplente && <span className='form__editarIndicador--error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errores.suplente}</span>}
                        </div>
                    </div>
                    {/* Etiquetas */}
                    <div className='w-100 d-flex flex-column flex-md-row align-items-center mb-2'>
                        <label className='me-1 col-12 col-md-3 col-form-label'>Etiquetas</label>
                        <div className='inputEtiquetas d-flex flex-column col-12 col-md-9'>
                            <input
                                className="form-control form-control-sm"
                                type="text"
                                value={inputValue}
                                onChange={handleChangeEtiquetas}
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                placeholder="Selecciona o escribe..."
                            />
                            {sugerenciasVisibles && sugerenciasFiltradas.length > 0 && (
                                <ul>
                                    {sugerenciasFiltradas.map((opcion) => (
                                        <li
                                            key={opcion.id_etiqueta}
                                            onMouseDown={() => handleClickOpcion(opcion)}
                                        >
                                            {opcion.nombre_etiqueta}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                    {modalErr !== null && <span className='align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                    <button type="submit" className='btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'>
                        Modificar Indicador
                    </button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalEditIndicador